import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api/client";
import { AuthContext } from "../context/AuthContext";
import "./Login.css";

function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [backgroundImage, setBackgroundImage] = useState("loginbackground4.png");
  const navigate = useNavigate();
  const { login, user, loading } = useContext(AuthContext);

  // Fetch the login background setting
  useEffect(() => {
    const fetchBackground = async () => {
      try {
        const res = await api.get("/system-settings/login-background");
        if (res.data?.imageFile) {
          setBackgroundImage(res.data.imageFile);
        }
      } catch (err) {
        // Use default background on error
        console.log("Using default login background");
      }
    };
    fetchBackground();
  }, []);


  useEffect(() => {
    if (!loading && user) {
      navigate("/dashboard", { replace: true });
    }
  }, [loading, navigate, user]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);

    try {
      const res = await api.post("/auth/login", {
        username,
        password,
      });

      const { token, user } = res.data;

      if (!token || !user) {
        throw new Error("Malformed response from server.");
      }

      login(token, user);
      navigate("/dashboard", { replace: true });
    } catch (err) {
      const message = err.response?.data ?? "Invalid login.";
      setError(typeof message === "string" ? message : "Invalid login.");
    }
    setSubmitting(false);
  };

  return (
    <div 
      className="login-page-wrapper"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.7)), url('${process.env.PUBLIC_URL}/${backgroundImage}')`,
      }}
    >
      <div className="login-container">
        <img
          className="login-logo"
          src={`${process.env.PUBLIC_URL}/rangervault.png`}
          alt="RangerVault"
        />
        <h2>RangerVault Login</h2>

        <form onSubmit={handleLogin}>
          <input
            style={{ width: "100%", padding: "10px", marginBottom: "10px" }}
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />

          <input
            style={{ width: "100%", padding: "10px", marginBottom: "10px" }}
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <button className="login-button" type="submit" disabled={submitting}>
            {submitting ? "Signing in..." : "Login"}
          </button>
        </form>

        {error && <p style={{ color: "red" }}>{error}</p>}

        <div className="login-created-by">
          <span>CREATED BY</span>
          <a href="https://darkstarenterprise.co" target="_blank" rel="noreferrer noopener" className="login-created-by__link">
            <img src={`${process.env.PUBLIC_URL}/darkstarenterpriseday.png`} alt="Darkstar Enterprise" />
          </a>
        </div>
      </div>
    </div>
  );
}

export default Login;